import { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Icon, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { objNotEmpty } from '../../utils/helpers';

const SearchBarV2 = ({
  actionToDispatch,
  searchPlaceholder,
  actionProps = {},
  customStyles,
  customIcon,
  ignoreIconClick,
  sendQueryAsObject,
  ...props
}) => {
  const dispatch = useDispatch()
  const searchInput = useRef('')
  const timeoutId = useRef()

  const searchOnBlur = () => {
    clearTimeout(timeoutId.current);

    timeoutId.current = setTimeout(() => {
      if (sendQueryAsObject) {
        dispatch(actionToDispatch({
          queries: { activeSearch: `${searchInput?.current?.value || ''}`, ...actionProps },
        }))
      } else if (objNotEmpty(actionProps)) {
        dispatch(actionToDispatch({
          queries: { searchText: `${searchInput?.current?.value || ''}`, ...actionProps },
          actionProps,
        }))
      } else {
        dispatch(actionToDispatch({
          queries: `${searchInput?.current?.value || ''}`,
        }))
      }
    }, 600);
  }
  const handelIconClick = () => {
    if (ignoreIconClick) return;
    searchOnBlur()
  }
  return (
    <Box sx={[styles.root, customStyles]} {...props}>
      <TextField
        fullWidth
        inputRef={searchInput}
        onChange={searchOnBlur}
        sx={styles.inputField}
        placeholder={searchPlaceholder}
        name="pageSearchBar"
        id="pageSearchBar"
      />

      <Box sx={styles.iconButton} onClick={handelIconClick} data-testid="search-icon-btn">
        {customIcon || <Icon component={SearchIcon} />}
      </Box>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    maxWidth: '550px',
    width: '100%',
    maxHeight: { sm: '40px' },
    marginBottom: { xs: '10px', sm: '20px' },
    minWidth: { xs: '100%', sm: '200px', md: '500px' },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      transform: 'translate(14px,12px) scale(1)',
    },
    '& .MuiFormControl-marginDense': {
      paddingRight: '0',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'background.default',
      borderRadius: '10px',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'grey.200',
      transition: 'all 0.3s ease-in-out',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      padding: '12px',
    },
    '& .MuiAlert-root': {
      width: '100%',
    },
  },
  inputField: {
    transition: 'all 0.5s ease',
    height: '40px',

    input: {
      padding: '0',
      paddingLeft: '40px',
      width: '100%',
      height: { xs: '32px', sm: '40px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '&::placeholder': {
        textTransform: 'capitalize',
        fontSize: { xs: '12px', sm: '14px' },
      },
    },
    '&:hover': {
      borderColor: 'primary.main',
    },
    fieldset: {
      border: 0,
      borderColor: 'unset',
    },
  },
  iconButton: {
    display: 'flex',
    position: 'absolute',
    left: '0',
    bottom: { xs: '3px', sm: 'unset' },
    width: '40px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 2,
    svg: {
      fontSize: '28px',
      color: 'text.hint',
    },
  },
}

export default SearchBarV2
